module.exports = __webpack_public_path__ + "img/tagback.6953aee3.png";